import { StyledSelect, StyledSelectAsync } from '../utils/Styled/select';
import PropTypes from 'prop-types';
import React from 'react';
import { LinkButton } from '../utils/Styled/buttons';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import Style from './style.scss';
import styled from 'styled-components';
import Highlighter from 'react-highlight-words';

export const StyledRow = styled(Row)`
  border-bottom-color: ${props => props.theme.borderColor};
`;

class FilterItem extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.clear = this.clear.bind(this);
    this.asyncOption = this.asyncOption.bind(this);
    this.maxOptionsLength = 499;
  }

  handleSelectChange(value) {
    value.caption = this.props.label;
    this.props.onChange(this.props.id, value);
  }

  clear() {
    this.handleSelectChange([]);
  }
  asyncOption(value) {
    return this.props.asyncOption(this.props.id, value);
  }
  renderOption(option) {
    return (
      <Highlighter
        searchWords={[this._inputValue]}
        textToHighlight={option.caption}
        highlightStyle={{ fontWeight: 'bold', backgroundColor: 'transparent' }}
      />
    );
  }

  render() {
    const topClassName = this.props.isTop ? 'menu-outer-top' : '';
    let select =
      this.maxOptionsLength > this.props.options.length ? (
        <StyledSelect
          className={topClassName}
          id={this.props.id}
          multi
          onChange={this.handleSelectChange}
          labelKey="caption"
          valueKey="id"
          options={this.props.options}
          placeholder={this.props.intlObject['ssp.scoreboard.search']}
          value={this.props.value}
          optionRenderer={this.renderOption.bind(this)}
          onInputChange={inputValue => (this._inputValue = inputValue)}
        />
      ) : (
        <StyledSelectAsync
          className={topClassName}
          multi
          value={this.props.value}
          onChange={this.handleSelectChange}
          labelKey="caption"
          placeholder={this.props.intlObject['ssp.scoreboard.search']}
          valueKey="id"
          optionRenderer={this.renderOption.bind(this)}
          onInputChange={inputValue => (this._inputValue = inputValue)}
          loadOptions={this.asyncOption}
        />
      );
    return (
      <StyledRow className={Style.filterRow}>
        <Col className={Style.col1}>
          <ControlLabel
            className={Style.filterLabel}
            title={this.props.label}
            htmlFor={this.props.id}
          >
            {this.props.label}
          </ControlLabel>
        </Col>
        <Col className={Style.col3}>
          <LinkButton
            bsStyle="link"
            disabled={!this.props.value || this.props.value.length === 0}
            onClick={this.clear}
          >
            {this.props.intlObject['ssp.scoreboard.clear']}
          </LinkButton>
        </Col>
        <Col className={Style.col2}>{select}</Col>
      </StyledRow>
    );
  }
}

FilterItem.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array,
  value: PropTypes.array,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  asyncOption: PropTypes.func,
  intlObject: PropTypes.object.isRequired,
  isTop: PropTypes.bool
};

export default FilterItem;



// WEBPACK FOOTER //
// ./components/Scoreboard/filterItem.js